var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAksi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 308,
    viewBox: "0 0 264 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 264,
    height: 307,
    rx: 6,
    fill: "#DFFFEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24.5,
    width: 96,
    height: 80,
    rx: 6,
    fill: "#44E48C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 24.5,
    width: 96,
    height: 80,
    rx: 6,
    fill: "#44E48C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 136.5,
    width: 96,
    height: 77.027,
    rx: 6,
    fill: "#44E48C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 223.797,
    width: 96,
    height: 7.7027,
    rx: 3.85135,
    fill: "#44E48C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 136.5,
    width: 96,
    height: 77.027,
    rx: 6,
    fill: "#44E48C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 223.797,
    width: 96,
    height: 7.7027,
    rx: 3.85135,
    fill: "#44E48C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 263.5,
    width: 100,
    height: 20,
    rx: 6,
    fill: "#44E48C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAksi);
export default __webpack_public_path__ + "static/media/aksi.c97e953763d87843cf8e63392e54cb97.svg";
export { ForwardRef as ReactComponent };